import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";

export const i18nInterceptor: HttpInterceptorFn = (req, next) => {
  const currentLocale = inject(TranslocoService).getActiveLang();

  req = req.clone({
    setHeaders: {
      "accept-language": currentLocale
    }
  });

  return next(req);
};
